import { render, staticRenderFns } from "./DatasetLobby.vue?vue&type=template&id=306976c2&scoped=true&"
import script from "./DatasetLobby.vue?vue&type=script&lang=js&"
export * from "./DatasetLobby.vue?vue&type=script&lang=js&"
import style0 from "./DatasetLobby.vue?vue&type=style&index=0&id=306976c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306976c2",
  null
  
)

export default component.exports